import AdBannerListAddButton from '@/components/test/AdBannerListAddButton';
import CardListAddButton from '@/components/test/CardListAddButton';

function Test() {
  return (
    <div>
      <CardListAddButton />
      <AdBannerListAddButton />
    </div>
  );
}

export default Test;
